module.exports = __webpack_public_path__ + "img/reset-password.1a7ce74b.png";